// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

const inlineSVGCache = new Map();

@Component({
  mixins: [template],
})
export default class InlineSVG extends Vue {
  @Prop({ default: "" })
  public src!: string;

  public svgCode: string | null = null;

  public loaded: boolean = false;

  async mounted() {
    const axios = require("axios");
    this.$el.innerHTML = this.src;

    if (!inlineSVGCache.has(this.src)) {
      try {
        inlineSVGCache.set(
          this.src,
          axios.get(this.src).then((r) => r.data)
        );
      } catch (e) {
        inlineSVGCache.delete(this.src);
        this.loaded = false;
      }
    }
    if (inlineSVGCache.has(this.src)) {
      this.svgCode = await inlineSVGCache.get(this.src);
      this.loaded = true;
    }
  }
}
